import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UserProfileDetails } from '../../../common/models/user.model';
import { NotificationSettingsResponse } from './notification-settings.model';
import { Observable, tap } from 'rxjs';
import { NotificationTypesResponse } from '../../../../ui-components/lib/notification/notifications-type.enum';
import { ENDPOINTS } from '../../../common/constants/endpoints.constants';
import { AuthService } from '../../../common/services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AccountSettingsService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);

  getProfileDetails() {
    return this.http.get<{ data: UserProfileDetails }>(
      ENDPOINTS.Auth.UserProfile
    );
  }

  /** Re-read the signed-in user's profile and sync it into the header (AuthService + cookie). */
  refreshCurrentUser() {
    return this.getProfileDetails().pipe(
      tap(({ data }) =>
        this.authService.updateCentralUser({
          first_name: data.first_name,
          last_name: data.last_name,
          name: data.name,
          image: data.image,
        })
      )
    );
  }

  editUserProfile(data: unknown) {
    return this.http.put(ENDPOINTS.Auth.UserProfile, data);
  }

  getNotificationSettings() {
    return this.http.get<NotificationSettingsResponse>(
      ENDPOINTS.AccountSettings.NotificationSettings
    );
  }

  saveNotificationSettings(
    notificationType: string,
    body: { channels: string[]; preferences?: number }
  ) {
    return this.http.post(
      `${ENDPOINTS.AccountSettings.NotificationSettings}?notification_type=${notificationType}`,
      body
    );
  }

  getNotificationTypes(): Observable<NotificationTypesResponse> {
    return this.http.get<NotificationTypesResponse>(
      ENDPOINTS.Lookup.NotificationTypes
    );
  }
}
